// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"346":"wp-content/themes/victorpattyn-theme/public/styles/admin","574":"wp-content/themes/victorpattyn-theme/public/styles/app","612":"wp-content/themes/victorpattyn-theme/public/styles/login","742":"wp-content/themes/victorpattyn-theme/public/styles/editor"}[chunkId] + ".css";
};